import PageState from '@/components/common/PageState';
import { ListBody, ListPageShell } from '@/components/common/organism/ListPageLayout';

/** 면허 인증 신청 화면 */
const LICENSE_VERIFICATION_PATH: string = '/profile/license-verification';

/**
 * 직군은 치과의사인데 면허 인증 전인 회원 — 속닥속닥 원장 공간도 위생사 공간도 아니다(서버가 목록·상세·글쓰기 모두 403).
 * 목록·상세·글쓰기 화면이 같은 안내를 쓴다.
 * @param inList 목록 본문(ListBody — 이미 좌우 16px) 안이면 true
 */
const PostSpaceLicenseNotice = ({ inList = false }: { inList?: boolean }) => {
    const notice = (
        <PageState
            title="면허 인증을 마치면 치과의사 공간을 쓸 수 있어요"
            description="치과의사 면허 인증을 마치면 원장님끼리 쓰는 속닥속닥 글을 읽고 쓸 수 있어요."
            action={{ label: '면허 인증하기', to: LICENSE_VERIFICATION_PATH }}
        />
    );
    // 상세·글쓰기 주소로 바로 들어와도 목록과 같은 흰 틀·좌우 여백(UI 가이드 6.1)
    return inList ? notice : (
        <ListPageShell>
            <ListBody>{notice}</ListBody>
        </ListPageShell>
    );
};

export default PostSpaceLicenseNotice;
